
import './styles.css';

import QuestionsTransactionsTable from '../../../questionsTransactionsTable';

export default function InstructorTransactionsModal({
  onCloseButtonClick,
  tableHeaders,
  transactionsData
}) {
 
  return (
    <div className={`modal-overlay`}>
      <div className="modal instructor-decision-insights-modal">
        <button className="close-button" onClick={onCloseButtonClick}></button>
        <QuestionsTransactionsTable 
          tableColumnHeader="Transactions"
          tableHeaders={tableHeaders}
          tableData={transactionsData}
        />
      </div>
    </div>
  );
}
